module.exports = __webpack_public_path__ + "static/media/list.b9bbc371.svg";